export const COURSE_CONTENT_MOCK_COURSES = [
  {
    id: 'course-qbeek-app',
    title: 'Приложение qbeek',
    accessLabel: 'Все роли',
    lessonCount: 4,
    itemsLoaded: true,
    items: [
      { id: 'lesson-authorization', type: 'lesson', title: 'Авторизация', label: 'Урок 1' },
      { id: 'lesson-create-order', type: 'lesson', title: 'Создание заказа', label: 'Урок 2' },
      { id: 'lesson-items-work', type: 'lesson', title: 'Работа с позициями', label: 'Урок 3' },
      { id: 'quiz-qbeek-work', type: 'quiz', title: 'Как вы поняли работу qbeek?', label: 'Викторина 1' },
      { id: 'game-correct-guess', type: 'game', title: 'Угадай, как правильно?', label: 'Игра 1' },
    ],
  },
  {
    id: 'course-welcome-training',
    title: 'Welcome тренинг',
    accessLabel: 'Все роли',
    lessonCount: 1,
    itemsLoaded: true,
    items: [],
  },
  {
    id: 'course-fire-safety',
    title: 'Правила пожарной безопасности',
    accessLabel: 'Все роли',
    lessonCount: 3,
    itemsLoaded: true,
    items: [],
  },
];

export const COURSE_CONTENT_DEFAULT_COURSE_FORM = {
  name: 'Приложение qbeek',
  description: 'Научит создавать, редактировать и закрывать заказ у стола в приложении qbeek.',
  roles: 'all',
  tags: [],
  status: 'active',
  affectsRating: true,
  ratingCategory: 'education',
  badgeEnabled: true,
  badge: 'gradient',
  thresholdNormal: '',
  thresholdGood: '',
  thresholdExcellent: '',
};

export const COURSE_CONTENT_DEFAULT_LESSON_FORM = {
  id: 'lesson-authorization',
  type: 'lesson',
  name: 'Авторизация',
  description: 'В данном уроке вы узнаете как скачать, получить доступы и авторизироваться в приложении qbeek.',
  cover: 'mock-cover',
  status: 'draft',
  active: true,
  required: true,
  shuffleAnswers: false,
  rules: null,
};

export const COURSE_CONTENT_ROLE_OPTIONS = [
  { value: 'all', label: 'Все роли' },
  { value: 'waiters', label: 'Официанты' },
  { value: 'managers', label: 'Менеджеры' },
];

export const COURSE_CONTENT_STATUS_OPTIONS = [
  { value: 'active', labelKey: 'education.courseStatusPublished' },
  { value: 'draft', labelKey: 'education.courseStatusDraft' },
  { value: 'disabled', labelKey: 'education.courseStatusInactive' },
];

export const COURSE_CONTENT_RATING_CATEGORY_OPTIONS = [
  { value: 'education', label: 'Обучение' },
  { value: 'service', label: 'Сервис' },
  { value: 'sales', label: 'Продажи' },
];

export const COURSE_CONTENT_BADGE_OPTIONS = [
  { value: 'clay', label: 'Silver star' },
  { value: 'gradient', label: 'Gradient star' },
  { value: 'premium', label: 'Gold star' },
];
